module.exports = __webpack_public_path__ + "img/button.0d7c5011.png";